import { Lock, LockPolicy } from "@common/types/lock";
import { lockContract } from "@common/contracts/lock.contract";
import { undoReconciliationLockBlockersQueryKey } from "@api/reconciliation.api";
import { queryClient, locksQueryKey } from "../queryClient";
import { getBackendAPIClient } from "./backendAPIClient";

const lockContractClient = getBackendAPIClient(lockContract);

export async function getLock(entityId?: number | null): Promise<Lock[]> {
    if (!entityId) {
        return [];
    }

    const {
        body: { locks },
    } = await lockContractClient.getLock({
        params: { entityId },
    });

    return locks;
}

export async function getLocks(entityIds: number[]): Promise<Lock[]> {
    if (entityIds.length === 0) {
        return [];
    }

    const response = await lockContractClient.getLocks({
        query: { entityIds },
    });

    return response.body.locks;
}

export async function updateLock({
    date,
    entityId,
    policy,
}: {
    date: string | null;
    entityId: number;
    policy: LockPolicy;
}) {
    const {
        body: { locks },
    } = await lockContractClient.updateLock({
        params: { entityId },
        body: { date, policy },
    });

    invalidateLockQueries();

    return locks;
}

export function invalidateLockQueries() {
    void queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === locksQueryKey,
    });
    void queryClient.invalidateQueries({
        queryKey: undoReconciliationLockBlockersQueryKey,
    });
}
